import Vue from 'vue'

// MODULES
import './modules/utilities/copyCode'

import Darkmode from './modules/layout/darkMode.js'

// layout
import Sidebar from './modules/layout/sidebar.js'

// VUEJS - COMPONENTS
import DrawerPanel from './vuejs/components/DrawerPanel.vue'
import DrawerPanelToggler from './vuejs/components/DrawerPanelToggler.vue'
import HotlineNumber from './vuejs/components/HotlineNumber.vue'

window.darkmode = new Darkmode({
  storage: true 
})

window.toastrOptions = {
  closeButton: true,
  debug: true,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "1000",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut"
};


document.addEventListener("DOMContentLoaded", function (event) {

  toastr.options = window.toastrOptions;
  
  /* TOGGLE LEFT SIDEBAR */
  if(document.getElementById('sidebar-toggle')) {
    let sidebarMain = new Sidebar({
      name: 'sidebarMain',
      elem: document.getElementById('main-sidebar'),
      toggler: document.getElementById('sidebar-toggle'),
      storage: false
    })
  }

  // INIT TOOLTIP
  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })

  // INIT VUE DRAWERPANEL
  if(document.querySelector('[data-vuejs="admin"]')) {
    new Vue({
      el: '[data-vuejs="admin"]',
      components: {
        DrawerPanel,
        DrawerPanelToggler
      },
      data: function() {
        return {
          lorem: '<b>lorem IPSUM</b>'
        }
      },
      mounted: function() {
        this.$el.classList.add('vue-initialized')
      }
    })
  }

  // INIT VUE CROP PHOTO PROFIL
  if (document.getElementById("profile-picture-area")) {
    new Vue({
      el: "#profile-picture-area",
      components: {
        "profile-picture-crop": () =>
          import("./vuejs/components/picture-crop.vue"),
      }
    });
  }

   // INIT VUE CROP PHOTO PROFIL
  if (document.getElementById("hotline")) {
    new Vue({
      el: "#hotline",
      components: {
        "HotlineNumber": () =>
          import("./vuejs/components/HotlineNumber.vue"),
      }
    });
  }


})


